"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageNames = void 0;
exports.LanguageNames = [
    'java',
    'tsx',
    'c_sharp',
    'php',
    'python',
    'ruby',
    'rust',
    'javascript',
    'go',
];
//# sourceMappingURL=types.js.map